// suver-gads-attribution.js — snippet para el TEMA de suver.cl
// (fuente de verdad: Cotizador/docs/suver-gads-attribution.js)
//
// Tres funciones, todas best-effort (jamás rompen la navegación):
//  1. Captura gclid/gbraid/wbraid al aterrizar desde un anuncio → localStorage
//     (90 días, la misma ventana de la acción de conversión) y lo registra en
//     el Cotizador con un código corto (POST /api/public/gads-ref).
//  2. Dispara el evento GA4 `email_click` en clics a mailto: — la medición
//     mejorada de GA4 NO captura mailto, por eso la acción de Ads llevaba
//     0 conversiones de por vida.
//  3. Anexa "ref:W-XXXXXX" al texto prellenado de WhatsApp — tanto en <a>
//     (header, móvil, página retiro, items del widget) como en window.open
//     (botón flotante) — para que el webhook del Cotizador una
//     clic → teléfono → cierre.
//
// La cotización web manda el clic directo: window.SuverGads.click() expone
// {gclid|gbraid|wbraid} para incluirlo como `gads` en POST /api/public/cotizar.
(function () {
  var KEY = "suver_gads";
  var TTL_MS = 90 * 86400000;
  var COTIZADOR = "https://cotizador-suver.up.railway.app";
  var ID_RE = /^[\w.-]{8,200}$/;
  var WA_RE = /(?:wa\.me|api\.whatsapp\.com)\//;

  function read() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY) || "null");
      if (!d || !d.ts || Date.now() - d.ts > TTL_MS) return null;
      return d;
    } catch (e) {
      return null;
    }
  }

  // Agrega "ref:W-XXXXXX" al parámetro text de una URL de WhatsApp.
  function withRef(urlStr) {
    var d = read();
    if (!d || !d.code) return urlStr;
    try {
      var u = new URL(urlStr, location.href);
      var t = u.searchParams.get("text") || "";
      if (t.indexOf("ref:W-") !== -1) return urlStr;
      u.searchParams.set("text", (t ? t + " " : "") + "ref:" + d.code);
      return u.toString();
    } catch (e) {
      return urlStr;
    }
  }

  // 1) Captura al aterrizar. El código es estable por visitante; un aterrizaje
  // posterior con OTRO clic actualiza el clic guardado (último clic pagado).
  try {
    var params = new URLSearchParams(location.search);
    var click = {};
    ["gclid", "gbraid", "wbraid"].forEach(function (k) {
      var v = params.get(k);
      if (v && ID_RE.test(v)) click[k] = v;
    });
    if (Object.keys(click).length > 0) {
      var prev = read();
      var code =
        (prev && prev.code) ||
        "W-" +
          Date.now().toString(36).slice(-3).toUpperCase() +
          Math.random().toString(36).slice(2, 5).toUpperCase();
      localStorage.setItem(
        KEY,
        JSON.stringify({ click: click, code: code, landing: location.pathname, ts: Date.now() })
      );
      fetch(COTIZADOR + "/api/public/gads-ref", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          code: code,
          landing: location.pathname,
          gclid: click.gclid,
          gbraid: click.gbraid,
          wbraid: click.wbraid,
        }),
        keepalive: true,
      }).catch(function () {});
    }
  } catch (e) {}

  // 2) email_click para GA4 (mailto no lo cubre la medición mejorada)
  document.addEventListener(
    "click",
    function (ev) {
      try {
        var a = ev.target && ev.target.closest ? ev.target.closest('a[href^="mailto:"]') : null;
        if (a && typeof window.gtag === "function") {
          window.gtag("event", "email_click", { link_url: a.getAttribute("href") });
        }
      } catch (e) {}
    },
    true
  );

  // 3a) ref en <a> de WhatsApp (fase captura: se reescribe antes de navegar)
  document.addEventListener(
    "click",
    function (ev) {
      try {
        var a = ev.target && ev.target.closest
          ? ev.target.closest('a[href*="wa.me/"],a[href*="api.whatsapp.com/"]')
          : null;
        if (!a) return;
        a.href = withRef(a.href);
      } catch (e) {}
    },
    true
  );

  // 3b) ref en window.open (botón flotante de WhatsApp construye la URL en JS)
  try {
    var _open = window.open;
    window.open = function (url) {
      try {
        if (typeof url === "string" && WA_RE.test(url)) {
          arguments[0] = withRef(url);
        }
      } catch (e) {}
      return _open.apply(window, arguments);
    };
  } catch (e) {}

  // API mínima para el carrito/cotizador web
  window.SuverGads = {
    click: function () {
      var d = read();
      return d ? d.click : null;
    },
    code: function () {
      var d = read();
      return d ? d.code : null;
    },
  };
})();
